import React, { useEffect, useContext, useState, Suspense, lazy } from 'react';
import UserContext from './store/UserContext.js';

import { Route, Routes, useLocation, } from 'react-router-dom';
import { auth, functions, onMessageListener } from './firebase.js';
import { ToastContainer, toast } from "react-toastify";
import './component/customCSS/MyReactToastify.css';


import Mainnav from './component/layout/Mainnav';
import CheckUserInDatabase from './store/CheckUserInDatabase.js';

import AnsweredQuestions from './Pages/AnsweredQuestions.js';
import PendingQuestions from './Pages/PendingQuestions';
import Notifications from './Pages/Notifications.js';
import HomeworkButler from './Pages/HomeworkButler.js';
import SubjectsSummaries from './Pages/SubjectsSummaries.js';
import AboutUs from './Pages/AboutUs.js';
import TermAndConditions from './Pages/TermAndConditions.js';
import Pricing from './Pages/Pricing.js';
import NotSubscribed from './Pages/NotSubscribed.js';
import SubscriptionForm from './component/SubscriptionForm.js';

import Webinars from './Pages/Webinars.js';
import Signin from './component/Signin.js';
import { httpsCallable } from 'firebase/functions';
import HomePage from './Pages/HomePageTemp.js';

import Bio from './Pages/Bio.js';
import TeacherProfile from './Pages/TeacherProfile.js';
import CourseList from './Pages/Courses.js';
import RedirectQuestaGlobal from './Pages/RedirectQuestaGlobal.js';


//import JoinTheTeam from './Pages/JoinTheTeam.js';
const JoinTheTeam = lazy(() => import('./Pages/JoinTheTeam.js'));
//import MyPayments from './Pages/MyPayments.js';
const MyPayments = lazy(() => import('./Pages/MyPayments.js'));



let signingup = false;
function App() {





  const userCtx = useContext(UserContext);
  const [user, setUser] = useState(null);

  const history = useLocation()



  useEffect(() => {

    userCtx.setSelectedPath(history.pathname)
    console.log(`You changed the page to: ${history.pathname}`)

  }, [history])





  function refreshUser() {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        authUser.getIdTokenResult().then((idTokenResult) => {
          console.log('is sign up main', signingup)
          // Confirm the user is an customer.
          console.log("claims", idTokenResult.claims);
          if (true
            // !!idTokenResult.claims.customer
          ) {
            // Show admin UI.
            console.log('is customer')
            setUser(authUser);
          } else {
            // Show regular user UI.
            console.log('is not customer')
            //   if (!signingup) auth.signOut()
            setUser(null);
          }
        }).catch((e) => console.log(e))

        console.log("current user is: ", authUser);
      } else {
        console.log("no user logged in");
        setUser(null);
      }
    })
  }

  useEffect(() => {
    refreshUser()
  }, [])



  onMessageListener()
    .then((payload) => {

      console.log("Received foreground message ", payload);

      toast(<div>
        <h3>{payload?.notification?.title}</h3>
        <h4>{payload?.notification?.body}</h4>
      </div>)

    })
    .catch((err) => console.log('failed: ', err));





  //let func = httpsCallable(functions, 'subscribeToTopics');

  let signin = <Signin isSigningUp={(state) => { signingup = state; console.log('is sign up state', state) }}
    refreshUser={() => auth.currentUser.getIdToken(true).then((e) => { refreshUser() })} />;
  let subscribe = <NotSubscribed />;



  function isSignedIn(component) {
    return user ? component : signin;
  }


  function withNavBar(component) {

    return <>
      <Mainnav />


      {/* {<button onClick={() => { func({ db: 'roles',id:'ejhPiqPQNLOgrWs8W5cWuMoAb2Q2',topics:['admin'] }).then((result) => { console.log('function execution', result.data) }) }}>call fb func</button>} */}

      {component}
    </>
  }

  function isActiveUser(component) {
    return isSignedIn(userCtx.isSubscribed ? component : subscribe);

  }




  return (

    <div>


      {!userCtx.isSettingInfo &&
        <>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route exact path="/ask" element={withNavBar(isActiveUser(<PendingQuestions />))} />
              <Route path='/courses' element={<CourseList/>} />
              <Route path='/' element={<RedirectQuestaGlobal/>} />
              <Route path='/home' element={withNavBar(<HomePage />)} />
              <Route path='/answered' element={withNavBar(isActiveUser(<AnsweredQuestions />))} />
              <Route path='/notification' element={withNavBar(isSignedIn(<Notifications />))} />
              <Route path='/contact_us' element={withNavBar(<HomeworkButler />)} />
              <Route path='/summaries' element={withNavBar(isActiveUser(<SubjectsSummaries />))} />
              <Route path='/about-us' element={withNavBar(<AboutUs />)} />
              <Route path='/pricing' element={withNavBar(<Pricing />)} />
              <Route path='/payments' element={withNavBar(isSignedIn(<MyPayments />))} />
              <Route path='/terms-conditions' element={withNavBar(<TermAndConditions />)} />
              <Route path='/subscription-form' element={withNavBar(isSignedIn(<SubscriptionForm />))} />
              <Route path='/join-the-team' element={withNavBar(<JoinTheTeam />)} />
              <Route path='/bio' element={<Bio />} />
              <Route path='/webinars' element={withNavBar(isActiveUser(<Webinars />))} />
              <Route path='*' element={withNavBar(isActiveUser(<PendingQuestions />))} />
              <Route path='/teacher/:id/:name' element={withNavBar(<TeacherProfile />)} />
            </Routes>
          </Suspense>
        </>}
      {user && auth.currentUser && <CheckUserInDatabase />}
      <ToastContainer />
    </div>

  );
}

export default App;

